export default "__VITE_ASSET__bdfccd80__"